module.exports = __webpack_public_path__ + "static/media/login-header-1920x720.7d914094.jpg";